
import { Link } from 'react-router-dom';
import { blogPosts, blogCategories } from '../../../mocks/blogPosts';

interface PostSidebarProps {
  currentPostId: string;
}

export default function PostSidebar({ currentPostId }: PostSidebarProps) {
  const related = blogPosts.filter((p) => p.id !== currentPostId).slice(0, 3);

  return (
    <aside className="space-y-8">
      {/* Categories */}
      <div className="bg-[#F9FBF7] rounded-xl p-6 border border-gray-100">
        <h4 className="text-sm font-semibold text-gray-900 mb-4 tracking-wide">
          <a href="/blog">CATEGORIES</a>
        </h4>
        <div className="space-y-2">
          {blogCategories.filter((c) => c !== 'All').map((cat) => {
            const count = blogPosts.filter((p) => p.category === cat).length;
            return (
              <Link
                key={cat}
                to="/blog"
                className="flex items-center justify-between py-2 px-3 rounded-lg text-sm text-gray-600 hover:bg-[#E8F5E9] hover:text-[#2E7D32] transition-colors cursor-pointer"
              >
                <span>{cat}</span>
                <span className="text-xs text-gray-400 bg-white px-2 py-0.5 rounded-full">{count}</span>
              </Link>
            );
          })}
        </div>
      </div>

      {/* Related Posts */}
      <div className="bg-[#F9FBF7] rounded-xl p-6 border border-gray-100">
        <h4 className="text-sm font-semibold text-gray-900 mb-4 tracking-wide">
          <a href="/blog">RELATED ARTICLES</a>
        </h4>
        <div className="space-y-4">
          {related.map((post) => (
            <Link
              key={post.id}
              to={`/blog/${post.id}`}
              className="flex gap-3 group cursor-pointer"
            >
              <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0">
                <img
                  src={post.image}
                  alt={post.title}
                  title={post.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-300"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h5 className="text-sm font-medium text-gray-800 leading-snug line-clamp-2 group-hover:text-[#2E7D32] transition-colors">
                  {post.title}
                </h5>
                <p className="text-[10px] text-gray-400 mt-1">{post.readTime}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* CTA */}
      <div className="bg-[#2E7D32] rounded-xl p-6 text-center">
        <div className="w-10 h-10 mx-auto mb-3 rounded-full bg-white/20 flex items-center justify-center">
          <i className="ri-leaf-line text-lg text-white"></i>
        </div>
        <p className="text-white font-serif text-lg mb-2">Explore Our Collection</p>
        <p className="text-white/70 text-xs mb-4 leading-relaxed">
          Discover handcrafted perfumes and hair oils made with nature&apos;s finest ingredients.
        </p>
        <Link
          to="/products"
          className="inline-block px-6 py-2.5 rounded-full bg-white text-[#2E7D32] text-xs font-semibold hover:bg-[#A5D6A7] transition-colors cursor-pointer whitespace-nowrap"
        >
          SHOP NOW
        </Link>
      </div>
    </aside>
  );
}
